import { useEffect, useRef, useState } from 'react';
import { brands as allBrands, type Brand } from '~/components/Brands';

export const useRandomBrands = ({
  cycle = true,
  count = 5,
  speed = 3e3,
}: {
  cycle: boolean;
  count: number;
  speed: number;
}) => {
  const [visible, setVisible] = useState<Brand[]>(allBrands.slice(0, count));
  const slotRef = useRef(0);
  const sourceRef = useRef(count);

  useEffect(() => {
    if (!cycle) {
      return;
    }

    const interval = setInterval(() => {
      const slot = slotRef.current;
      const source = sourceRef.current % allBrands.length;
      const next = allBrands[source];

      setVisible((prev) => {
        const updated = [...prev];
        updated[slot] = next ?? prev[slot]!;
        return updated;
      });

      slotRef.current = (slot + 1) % count;
      sourceRef.current = source + 1;
    }, speed);

    return () => clearInterval(interval);
  }, [cycle, count, speed]);

  return visible;
};
